<template lang="html">
    <div id='app'>
        <!-- Top bar-->
        <detail-header/>
        <!-- Begin Page Content -->
        <components v-bind:is="Content" v-on:change-view="goPage" :properties="properties" />
    </div>
</template>

<script>
  import Header from '@/views/Common/Header.vue' 
  import Form from '@/views/Analysis/Pipeline/DetailForm.vue'
  import common from '@/views/Common/common.js'

  export default {
    name: 'Detail',
    components: 
    {
      'detail-header': Header,
      'detail-Form': Form,
    },
    created () {
    },
    mounted(){
      //화면 새로고침시 기존 화면 불러오기
      if(!common.isNull(this.$route.params.mid)){
        this.goPage({'mid':this.$route.params.mid, 'uid': this.$route.params.uid, 'type':this.$route.params.type});
      }else{
        this.goPage({'mid':sessionStorage.mid, 'uid':sessionStorage.uid, 'type':sessionStorage.type});
      }
    },
    data () {
      return {
        Content: '',
        listRoute: '',
        properties:[],
      }
    },
    methods: {
      goPage(data){
        this.Content = 'detail-Form'
        this.properties = data;
        sessionStorage.removeItem('type');
        sessionStorage.removeItem('uid');
        sessionStorage.removeItem('mid');
        sessionStorage.setItem('type', data.type);
        sessionStorage.setItem('uid',common.isNull(data.uid) ? '': data.uid);
        sessionStorage.setItem('mid',data.mid);
      },
      menuData(data){
        this.properties.menuData = data;
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Analysis/Pipeline/Detail.vue